import { h, Component } from 'preact';
import { calcImagePositionForFocalPoint } from 'utils/media';

export default class Image extends Component {
	constructor(props) {
		super(props);
		this.onLoad = this.onLoad.bind(this);
	}

	componentDidMount() {
		// Handle cached images that are already loaded
		if (this.$img?.complete && this.$img?.naturalWidth) {
			this.forceUpdate(); // Re-render to recalc object position with loaded dimensions
		}
	}

	onLoad() {
		if (this.props.onLoad) this.props.onLoad();
		this.forceUpdate(); // Re-render to recalc object position with loaded dimensions
	}

	calcObjectPosition() {
		const { focalX, focalY } = this.props.focalPoint || {};
		const { clientWidth, clientHeight, naturalWidth, naturalHeight } = this.$img || {};
		return calcImagePositionForFocalPoint(naturalWidth, naturalHeight, clientWidth, clientHeight, focalX, focalY);
	}

	render() {
		const style = this.props.style || {};
		const objectPosition = this.calcObjectPosition();

		return (
			<img
				{...this.props}
				ref={$el => (this.$img = $el)}
				onLoad={this.onLoad}
				style={{ ...style, objectPosition, objectFit: 'cover' }}
			/>
		);
	}
}